import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft, FiMail, FiPhone, FiCalendar, FiTrash2, FiUser } from 'react-icons/fi';
import { UseToast } from '../../hooks/UseToast';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const ContactMessageDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = UseToast();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchMessage(); }, [id]);

  const fetchMessage = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/messages/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) setMessage(data.data);
      else navigate('/contact-messages');
    } catch (e) {
      toast.error('Failed to load');
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this message?')) return;
    const token = localStorage.getItem('token');
    const res = await fetch(`${API_URL}/messages/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (data.success) {
      toast.success('Deleted');
      navigate('/contact-messages');
    }
  };

  if (loading) return <div style={{ padding: 60, textAlign: 'center' }}>Loading...</div>;
  if (!message) return null;

  return (
    <>
      <style>{`
       .detail-page { font-family: 'Outfit', sans-serif; background: #F8FAFC; min-height: 100vh; padding: 24px; }
       .back-btn { display: inline-flex; align-items: center; gap: 8px; padding: 10px 16px; background: #F1F5F9; border: none; border-radius: 10px; color: #475569; font-weight: 600; cursor: pointer; margin-bottom: 20px; }
       .detail-card { background: #FFF; border-radius: 16px; padding: 32px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); }
       .detail-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #E2E8F0; padding-bottom: 20px; margin-bottom: 24px; }
       .detail-title { font-size: 28px; font-weight: 800; color: #0F172A; margin:0; text-transform: capitalize; }
       .info-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 32px; margin-bottom: 32px; }
       .info-label { font-size: 13px; color: #64748B; margin-bottom: 6px; display: block; }
       .info-value { font-size: 16px; font-weight: 700; color: #0F172A; margin:0; word-break: break-all; }
       .message-box { background: #F8FAFC; padding: 20px; border-radius: 12px; border-left: 4px solid #3B82F6; }
        @media (max-width: 768px) {.info-grid { grid-template-columns: 1fr; } }
      `}</style>

      <div className="detail-page">
        <button className="back-btn" onClick={() => navigate('/contact-messages')}>
          <FiArrowLeft /> Back to Messages
        </button>

        <div className="detail-card">
          <div className="detail-header">
            <h1 className="detail-title">{message.name}</h1>
            <button onClick={handleDelete} style={{ background: '#FEE2E2', color: '#EF4444', border: 'none', padding: '12px 20px', borderRadius: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <FiTrash2 /> Delete
            </button>
          </div>

          <div className="info-grid">
            <div>
              <span className="info-label">Email</span>
              <p className="info-value">{message.email}</p>
            </div>
            <div>
              <span className="info-label">Subject</span>
              <p className="info-value">{message.subject}</p>
            </div>
            <div>
              <span className="info-label">Phone Number</span>
              <p className="info-value" style={{ display: 'flex', alignItems: 'center', gap: 8 }}><FiPhone /> {message.phone || 'Not provided'}</p>
            </div>
            <div>
              <span className="info-label">Date</span>
              <p className="info-value">{new Date(message.createdAt).toLocaleString('en-IN', { day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })}</p>
            </div>
          </div>
          <div>
            <h3 style={{ fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}><FiMail /> Message</h3>
            <div className="message-box">
              {message.message}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactMessageDetail;